export const isAllowedSite = (referrerURL: string, referringSites: string[]): boolean => {
  return referringSites.some(site => referrerURL.includes(site))
}

export default isAllowedSite
